import { FunctionComponent } from 'react';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { $SkeletonButtonStyled } from './Skeleton.styles';

const SkeletonButton: FunctionComponent<{ highContrast: boolean }> = ({
  highContrast = false,
}) => {
  return (
    <$SkeletonButtonStyled
      $highContrast={highContrast}
      $isInline={false}
      $width="100%"
      $height={rem(14)}
      $marginBottom="0"
      $isCircle={false}
    />
  );
};

SkeletonButton.displayName = 'SkeletonButton';

export default SkeletonButton;
